import _styled from "@emotion/styled-base";
import React from 'react';
import PropTypes from 'prop-types';
import { Error } from "./Error";
import { FieldLabel } from "./FieldLabel";
import { jsx as ___EmotionJSX } from "@emotion/core";
const StdWrapper = /*#__PURE__*/_styled('div', {
  target: "e1i1cr5y0"
})("position:relative;margin-bottom:32px;color:", _ref => {
  let {
    theme
  } = _ref;
  return theme.text.medium;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
/**
 * Structure for standard fields
 */
export const FieldStructure = _ref2 => {
  let {
    children,
    className,
    error,
    hideError,
    id,
    invalid,
    inlinelabel,
    label,
    required
  } = _ref2;
  return ___EmotionJSX(StdWrapper, {
    className: className
  }, ___EmotionJSX(FieldLabel, {
    inlinelabel: inlinelabel,
    id: id,
    label: label,
    required: required,
    showColon: false
  }), children, ___EmotionJSX(Error, {
    show: invalid || hideError,
    error: error
  }));
};
FieldStructure.defaultProps = {
  required: false
};
FieldStructure.propTypes = {
  /** The field you want to add Structure to: */
  children: PropTypes.element.isRequired,
  /** Optional className for styling */
  className: PropTypes.string,
  /** The error message associated to the field. */
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /** Will hide the error even if it exists. */
  hideError: PropTypes.bool,
  /** The id of the input to set as htmlFor on the label. */
  id: PropTypes.string.isRequired,
  /** To set the lable inline for field */
  inlinelabel: PropTypes.bool,
  /** `true` if the field has been touched and is in error state. */
  invalid: PropTypes.bool,
  /** Label for the field. */
  label: PropTypes.node,
  /** If the field is required. If false show '(Optional)'. */
  required: PropTypes.bool
};